module.exports = __webpack_public_path__ + "static/img/pic.6b69d19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/carCompare/images/pic.jpg
// module id = BAXi
// module chunks = 36